import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const AdminSettings = () => {
  const [asaasApiKey, setAsaasApiKey] = useState('');
  const [asaasApiUrl, setAsaasApiUrl] = useState('https://sandbox.asaas.com/v3');
  const [asaasWebhookSecret, setAsaasWebhookSecret] = useState('');
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maxTenants, setMaxTenants] = useState(100);
  const [aiProvider, setAiProvider] = useState('openai');
  const [globalAiApiKey, setGlobalAiApiKey] = useState('');
  const [saveStatus, setSaveStatus] = useState(null);
  
  const [testAiStatus, setTestAiStatus] = useState('Testar Conexão');
  const [testAiResult, setTestAiResult] = useState(null);

  const webhookUrl = `${window.location.origin}/billing/webhook`;

  useEffect(() => {
    apiFetch('/admin/settings')
    .then(res => res.json())
    .then(data => {
      // Remover aspas que podem vir serializadas em JSON
      const clean = (val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return val;
          }
        }
        return val;
      };

      if (data.asaas_api_key) setAsaasApiKey(clean(data.asaas_api_key));
      if (data.asaas_api_url) setAsaasApiUrl(clean(data.asaas_api_url));
      if (data.asaas_webhook_secret) setAsaasWebhookSecret(clean(data.asaas_webhook_secret));
      if (data.maintenance_mode !== undefined) setMaintenanceMode(clean(data.maintenance_mode) === true || clean(data.maintenance_mode) === 'true');
      if (data.max_tenants) setMaxTenants(Number(clean(data.max_tenants)));
      if (data.ai_provider) setAiProvider(clean(data.ai_provider));
      if (data.global_ai_api_key) setGlobalAiApiKey(clean(data.global_ai_api_key));
    })
    .catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaveStatus('Salvando...');
    try {
      const resp = await apiFetch('/admin/settings', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          asaas_api_key: asaasApiKey,
          asaas_api_url: asaasApiUrl,
          asaas_webhook_secret: asaasWebhookSecret,
          maintenance_mode: maintenanceMode,
          max_tenants: parseInt(maxTenants),
          ai_provider: aiProvider,
          global_ai_api_key: globalAiApiKey
        })
      });
      if (resp.ok) {
        setSaveStatus('Sucesso');
      } else {
        setSaveStatus('Erro ao salvar');
      }
    } catch (e) {
      setSaveStatus('Erro de conexão');
    }
    setTimeout(() => setSaveStatus(null), 3000);
  };

  const handleTestAIKey = async () => {
    setTestAiStatus('Testando...');
    setTestAiResult(null);
    try {
      const resp = await apiFetch('/admin/settings/test-ai', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          provider: aiProvider,
          api_key: globalAiApiKey
        })
      });
      const data = await resp.json();
      if (resp.ok) {
        setTestAiResult('✓ Conexão estabelecida com sucesso!');
      } else {
        setTestAiResult(`❌ Falha no teste: ${data.detail || 'Erro desconhecido'}`);
      }
    } catch (e) {
      setTestAiResult('❌ Erro de conexão com o servidor.');
    } finally {
      setTestAiStatus('Testar Conexão');
    }
  };

  return (
    <div className="animate-fade">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h2>Configuração Global da Plataforma SaaS</h2>
          <p className="stat-label">Parâmetros essenciais de faturamento Asaas, inteligência artificial e capacidade global.</p>
        </div>
      </div>

      <div className="stat-card" style={{ padding: '2rem' }}>
        <h3 style={{ marginBottom: '1.5rem', color: '#fbbf24', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '0.5rem' }}>Gateway de Pagamentos (Asaas)</h3>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Ambiente API Asaas</label>
          <select 
            className="login-input" 
            value={asaasApiUrl} 
            onChange={(e) => setAsaasApiUrl(e.target.value)}
            style={{ width: '100%', maxWidth: '400px', cursor: 'pointer' }}
          >
            <option value="https://sandbox.asaas.com/v3">Sandbox (Homologação / Testes)</option>
            <option value="https://api.asaas.com/v3">Production (Produção / Vendas Reais)</option>
          </select>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Chave de API Asaas</label>
          <input 
            type="password"
            className="login-input"
            value={asaasApiKey}
            onChange={(e) => setAsaasApiKey(e.target.value)}
            placeholder="Cole o token de acesso da sua conta Asaas ($aact_...)"
            style={{ width: '100%', maxWidth: '500px' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Token Secreto do Webhook</label>
          <input 
            type="password"
            className="login-input"
            value={asaasWebhookSecret}
            onChange={(e) => setAsaasWebhookSecret(e.target.value)}
            placeholder="Defina o token de autenticação do webhook"
            style={{ width: '100%', maxWidth: '500px' }}
          />
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.5rem' }}>Este token é usado para verificar a assinatura das requisições enviadas pelo Asaas.</p>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>URL do Webhook (Destino no Asaas)</label>
          <input 
            type="text"
            className="login-input"
            value={webhookUrl}
            readOnly
            style={{ width: '100%', maxWidth: '500px', background: 'rgba(255,255,255,0.02)', color: '#94a3b8', cursor: 'pointer' }}
            onClick={(e) => {
              e.target.select();
              navigator.clipboard.writeText(webhookUrl);
              alert('URL copiada para a área de transferência!');
            }}
          />
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.5rem' }}>Copie esta URL e registre-a no painel do Asaas para escutar eventos de cobrança.</p>
        </div>

        <h3 style={{ marginBottom: '1.5rem', marginTop: '3rem', color: '#4ade80', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '0.5rem' }}>Motor de Inteligência Artificial (Barker)</h3>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Provedor LLM Global</label>
          <select 
            className="login-input" 
            value={aiProvider} 
            onChange={(e) => setAiProvider(e.target.value)}
            style={{ width: '100%', maxWidth: '400px', cursor: 'pointer' }}
          >
            <option value="openai">OpenAI (GPT-4o-mini)</option>
            <option value="gemini">Google Gemini (2.0 Flash)</option>
            <option value="deepseek">DeepSeek (V3 Chat)</option>
            <option value="anthropic">Anthropic (Claude 3.5)</option>
            <option value="mistral">Mistral AI (Nuvem)</option>
            <option value="ollama">Ollama (Local/On-Premise)</option>
          </select>
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.5rem' }}>Define o modelo padrão que processará as chamadas de IA da plataforma.</p>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Chave de API LLM Global</label>
          <div style={{ display: 'flex', gap: '10px', maxWidth: '500px' }}>
            <input 
              type="password" 
              className="login-input" 
              value={globalAiApiKey} 
              onChange={(e) => setGlobalAiApiKey(e.target.value)}
              placeholder="Cole a chave de API global do provedor selecionado"
              style={{ flex: 1 }}
            />
            <button 
              className="btn-secondary" 
              onClick={handleTestAIKey} 
              disabled={testAiStatus === 'Testando...'}
              style={{ 
                whiteSpace: 'nowrap', 
                padding: '0px 20px', 
                borderRadius: '10px', 
                background: 'rgba(255,255,255,0.05)', 
                color: 'var(--text-primary)', 
                border: '1px solid var(--border)', 
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              {testAiStatus}
            </button>
          </div>
          {testAiResult && (
            <p style={{ color: testAiResult.includes('sucesso') ? '#4ade80' : '#ef4444', fontSize: '0.85rem', marginTop: '0.5rem', fontWeight: 'bold' }}>
              {testAiResult}
            </p>
          )}
        </div>

        <h3 style={{ marginBottom: '1.5rem', marginTop: '3rem', color: '#38bdf8', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '0.5rem' }}>Capacidade e Limites Globais</h3>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Limite Máximo Global de Inquilinos (Tenants)</label>
          <input 
            type="number" 
            className="login-input" 
            value={maxTenants} 
            onChange={(e) => setMaxTenants(e.target.value)}
            style={{ width: '100%', maxWidth: '150px' }}
          />
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.5rem' }}>Usado para prevenir sobrecarga da infraestrutura nas fases iniciais.</p>
        </div>

        <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <input 
            type="checkbox" 
            id="maintenance" 
            checked={maintenanceMode}
            onChange={(e) => setMaintenanceMode(e.target.checked)}
            style={{ width: '20px', height: '20px', accentColor: '#ff4444' }}
          />
          <label htmlFor="maintenance" style={{ fontWeight: 'bold', color: maintenanceMode ? '#ff4444' : 'inherit', cursor: 'pointer' }}>
            Ativar Modo Manutenção (Bloqueia novos Logins)
          </label>
        </div>

        <div style={{ marginTop: '3rem', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '2rem', display: 'flex', alignItems: 'center', gap: '20px' }}>
          <button className="btn-primary" onClick={handleSave} style={{ minWidth: '200px' }}>
            Gravar Configurações
          </button>
          {saveStatus && (
            <span style={{ color: saveStatus === 'Sucesso' ? '#4ade80' : '#fbbf24', fontWeight: 'bold' }}>
              {saveStatus === 'Sucesso' ? '✓ Configurações salvas no servidor.' : '↻ Atualizando...'}
            </span>
          )}
        </div>

      </div>
    </div>
  );
};

export default AdminSettings;
